import Vue from 'vue'
import Vuex from 'vuex'

import peers from '@/store/modules/peers'
import whiteboard from '@/store/modules/whiteboard'
import projector from '@/store/modules/projector'
import minutes from '@/store/modules/minutes'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    resetModules: function({ commit }) {
      commit('peers/resetModule')
      commit('whiteboard/resetModule')
      commit('projector/resetModule')
      commit('minutes/resetModule')
    }
  },
  modules: {
    peers,
    whiteboard,
    projector,
    minutes
  }
})
